import { Conditional } from '@consumidor-positivo/aurora';
import HeadingSection from './components/HeadingSection';
import useClosedAgreement from './hooks';
import PaymentData from './components/PaymentData';
import DebitAccount from './components/DebitAccount';
import Retry from './components/Retry';
import './styles.scss';

const ClosedAgreement = () => {
  const {
    closedAgreement,
    debtData,
    qrCodeUrl,
    isPixExternal,
    pixText,
    billet,
    hasBillet,
    handleCopyPixCode,
    isPixSuccess,
    pixCode,
    warningRef,
    selectedBankAccount,
    firstInstallmentExpDate,
    isPollingBillet,
    handleUpdateContactData,
    handleSeeAgreementDetails,
    isFirstInstallmentPaid,
    shouldRedirectToDebitAccount,
    handleRedirectToMyDebts,
    retryError,
    isLoadingCAPix,
    isItauDesenrola,
  } = useClosedAgreement();

  return (
    <div className="closed-agreement-page">
      <Conditional
        condition={retryError}
        renderIf={
          <div className="closed-agreement-page__payment-page">
            <Retry
              debtData={debtData}
              handleRedirectToMyDebts={handleRedirectToMyDebts}
              closedAgreement={closedAgreement}
              firstInstallmentExpDate={firstInstallmentExpDate}
            />
          </div>
        }
        renderElse={
          <>
            <Conditional
              condition={shouldRedirectToDebitAccount}
              renderIf={
                <DebitAccount
                  debtData={debtData}
                  firstInstallmentExpDate={firstInstallmentExpDate}
                  handleSeeAgreementDetails={handleSeeAgreementDetails}
                  selectedBankAccount={selectedBankAccount}
                  handleUpdateContactData={handleUpdateContactData}
                />
              }
            />

            <Conditional
              condition={!shouldRedirectToDebitAccount}
              renderIf={
                <div className="closed-agreement-page__payment-page">
                  <HeadingSection
                    withoutPaymentData={!hasBillet && !pixCode}
                    isFirstInstallmentPaid={isFirstInstallmentPaid}
                    debtData={debtData}
                    firstInstallmentExpDate={firstInstallmentExpDate}
                  />

                  <div className="closed-agreement-page__container">
                    <PaymentData
                      hasBillet={hasBillet}
                      isPollingBillet={isPollingBillet}
                      pixCode={pixCode}
                      isPixExternal={isPixExternal}
                      billet={billet}
                      isPixSuccess={isPixSuccess}
                      qrCodeUrl={qrCodeUrl}
                      handleCopyPixCode={handleCopyPixCode}
                      pixText={pixText}
                      warningRef={warningRef}
                      closedAgreement={closedAgreement}
                      isFirstInstallmentPaid={isFirstInstallmentPaid}
                      debtData={debtData}
                      handleSeeAgreementDetails={handleSeeAgreementDetails}
                      firstInstallmentExpDate={firstInstallmentExpDate}
                      handleUpdateContactData={handleUpdateContactData}
                      handleRedirectToMyDebts={handleRedirectToMyDebts}
                      isLoadingCAPix={isLoadingCAPix}
                      isItauDesenrola={isItauDesenrola}
                    />
                  </div>
                </div>
              }
            />
          </>
        }
      />
    </div>
  );
};

export default ClosedAgreement;
